import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { publicUsefulLinksUrl } from 'SharedDir/backend/endpoints/public-useful-links';
import { UsefulLinks } from 'SharedDir/declarations/useful-links';

export default class PublicUsefulLinksApiClass extends SimpleApi<
  UsefulLinks.UsefulLinksFull,
  never,
  never,
  UsefulLinks.UsefulLinksBare
> {
  constructor() {
    super(publicUsefulLinksUrl);
  }
}
